import MySubEvaluationsListController from './mySubEvaluationsListController';
import UserService from '../../user/services/userService';
import './mySubEvaluationsList.scss';
import DateFormatFilter from '../../../filters/dateFormat';

const MySubEvaluationsListComponent = {
    template: require('./mySubEvaluationsListView.html'),
    controller: MySubEvaluationsListController
};

MySubEvaluationsListController.$inject = ['$http', '$filter', '$stateParams', '$mdDialog', '$state', 'EvaluationService', 'UserService'];

export default angular.module('app.mysubevaluationslist', [require('angular-material-data-table')])
    .component('mysubevaluationslist', MySubEvaluationsListComponent)
    .filter('dateFormat', DateFormatFilter)
    .service('UserService', UserService)
    .name;


// WEBPACK FOOTER //
// ./src/app/pages/lists/mySubEvaluationList/mySubEvaluationsListComponent.js